import script from "./StepIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./StepIndicator.vue?vue&type=style&index=0&id=4d051292&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d051292"]])

export default __exports__